import type { StripeSubscriptionStatus } from '@albacross/types'

import type { StatusSeverity } from 'components/_base/StatusChip'

// 'unknown' is normal: AppSumo, agency and manually-provisioned accounts have no Stripe subscription.
export const SUBSCRIPTION_STATUS: Record<StripeSubscriptionStatus, { label: string; severity: StatusSeverity }> = {
  active: { label: 'Active', severity: 'success' },
  trialing: { label: 'Trialing', severity: 'info' },
  past_due: { label: 'Past due', severity: 'error' },
  unpaid: { label: 'Unpaid', severity: 'error' },
  incomplete_expired: { label: 'Incomplete, expired', severity: 'error' },
  incomplete: { label: 'Incomplete', severity: 'warning' },
  canceled: { label: 'Cancelled', severity: 'warning' },
  paused: { label: 'Paused', severity: 'warning' },
  unknown: { label: 'None', severity: 'default' },
}

export const subscriptionStatus = (status?: string) =>
  SUBSCRIPTION_STATUS[status as StripeSubscriptionStatus] ?? {
    label: status || 'Unknown',
    severity: 'default' as const,
  }
